import { DatapointIdStandardEnum, DatapointsEntityType } from "api/ux/src";
import { InspectDataTab } from "components/modal/widget-inspect-data/types";
const shouldSendClicthroughMeasures = (params, entityType) => {
    if (entityType === DatapointsEntityType.FundSeries) {
        return false;
    }
    if (!params.dimensions || params.dimensions.length === 0) {
        return entityType === DatapointsEntityType.Asset || entityType === DatapointsEntityType.Fund;
    }
    return params.dimensions?.some((e) => e.standardDatapoint === DatapointIdStandardEnum.FundFundId ||
        e.standardDatapoint === DatapointIdStandardEnum.AssetAssetId ||
        e.standardDatapoint === DatapointIdStandardEnum.InstrumentInstrumentId);
};
export const getClickthroughMeasures = (params, clickthroughDatapoints, entityType) => {
    if (entityType === DatapointsEntityType.FundSeries) {
        return [];
    }
    if (!clickthroughDatapoints || !shouldSendClicthroughMeasures(params, entityType)) {
        return [];
    }
    const newMeasures = params.measures
        .filter((m) => m.standardDatapoint && clickthroughDatapoints[m.standardDatapoint])
        .map((x) => ({
        ...x,
        context: {
            insightDatapoint: { standard: x.standardDatapoint },
            ...x.context ?? {}
        },
        name: `${"clickthrough-"}${x.name}`,
        standardDatapoint: DatapointIdStandardEnum.DatapointMetadata
    }));
    if (params.dimensions?.some((e) => e.standardDatapoint === DatapointIdStandardEnum.FundFundId) ||
        (!params.dimensions && entityType === DatapointsEntityType.Fund)) {
        newMeasures.push({
            name: "fundMasterId",
            standardDatapoint: DatapointIdStandardEnum.FundFundMasterId
        });
    }
    if (params.dimensions?.some((e) => e.standardDatapoint === DatapointIdStandardEnum.AssetAssetId ||
        e.standardDatapoint === DatapointIdStandardEnum.InstrumentInstrumentId) ||
        (!params.dimensions && entityType === DatapointsEntityType.Asset)) {
        newMeasures.push({
            name: "assetMasterId",
            standardDatapoint: DatapointIdStandardEnum.AssetAssetMasterId
        });
    }
    return newMeasures;
};
const shouldAddClickthroughMeasures = (params, displayedLevel, entityType, timePeriod) => displayedLevel === InspectDataTab.FullHistory &&
    entityType !== DatapointsEntityType.FundSeries &&
    !params?.insertAdditionalColumnOnInspectData &&
    (params.measures.some((x) => x.timeSeries) ||
        (timePeriod && params.measures.some((x) => x.periods !== 1)) ||
        entityType === DatapointsEntityType.Asset ||
        params.dimensions?.some((x) => x.standardDatapoint === DatapointIdStandardEnum.FundFundStatus));
export const shouldEarlyReturnClickthrough = (params, displayedLevel, entityType, timePeriod, clickthroughDatapoints) => {
    if (entityType === DatapointsEntityType.FundSeries) {
        return false;
    }
    if (shouldAddClickthroughMeasures(params, displayedLevel, entityType, timePeriod)) {
        params.measures.push(...getClickthroughMeasures(params, clickthroughDatapoints, entityType));
        return true;
    }
    return false;
};
